export const senderId = (countryCode: string, sms: string, email: string) => {
    return {
        countryCode,
        sms,
        email
    };
}

